import cn from "classnames";
import { FC, ReactNode } from "react";

type FeatureOverviewProps = {
  children: ReactNode;
};

const FeatureOverview: FC<FeatureOverviewProps> = ({ children }) => {
  return <div className="bg-background-highlight p-6 lg:p-8">{children}</div>;
};

export default FeatureOverview;
